import { isWechat } from "./tool";

if (isWechat()) {
  const root = document.querySelector(":root");
  root.style.setProperty("--header-bar-height", "0px");
}
